module.exports = __webpack_public_path__ + "img/android.9b4545bb.png";